// eslint-disable-next-line no-undef
export const getCurrentLang = () => typeof hae_current_lang !== "undefined" ? hae_current_lang : 'fr'

export const getWPUrl = () => {
    if (process.env.NODE_ENV === 'development') {
        const url = process.env.VUE_APP_WORDPRESS_URL
        if (!url) {
            console.warn("VUE_APP_WORDPRESS_URL is not set in .env.development file, to load images, please set it")
        }
        return url
    }
    return ''
}